import { winMixBarPercentages } from "@/lib/ModelEvaluationKpis";

type Props = {
    model_wins: number;
    norm_wins: number;
    fallback_count: number;
};

export default function WinMixBar(props: Props) {
    const mix = winMixBarPercentages(props.model_wins, props.norm_wins, props.fallback_count);
    if (mix.total <= 0) {
        return <div className="win-split-bar win-split-bar-empty" role="img" aria-label="No mix data" />;
    }
    const gradient = `linear-gradient(to right, #c8e6c9 0%, #c8e6c9 ${mix.model_pct}%, #ffcdd2 ${mix.model_pct}%, #ffcdd2 ${mix.norm_pct}%, #cfd8dc ${mix.norm_pct}%, #cfd8dc 100%)`;
    const label = `Operations mix: model wins ${props.model_wins}, norm wins ${props.norm_wins}, fallback ${props.fallback_count}`;
    return <div className="win-split-bar" role="img" aria-label={label} style={{ background: gradient }} />;
}
